module.exports = __webpack_public_path__ + "sit2.png?c1fdbf62beb908886270f4d6ccbf4dcd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photoplio/sit2.png
// module id = 72
// module chunks = 0